export default __webpack_public_path__ + "static/media/Group 2144.d0a207f9.svg";